import Icon from '../Icon';
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import QRCode from 'qrcode.react';
import ShareCodeButton from '../share/ShareCodeButton';
import { CreativeTVLink } from '../CreativeDisplayBridge';
export default function ShareCodeCard() {
  const { urlGameCode: code } = useParams();
  return <section className="creative-form" style={{textAlign:'center'}}>
    <CreativeTVLink code={code} />
    <span className="eyebrow">YOUR TABLE IS OPEN</span><h1>Get the group in.</h1>
    <p>Invite at least three friends. Everyone writes on their own phone. Play on the host’s phone or connect a TV.</p>
    <div className="room-code">{code}</div>
    <div><QRCode value={window.location.origin + '/creative-mode/' + code + '/enter-prompts'} size={150} includeMargin /></div>
    <p>Scan to join, or enter the code on the home page.<ShareCodeButton code={code} /></p>
    <Link className="button dark full" to={'/creative-mode/' + code + '/enter-prompts'}>Write my prompts <Icon name="arrow-right" /></Link>
  </section>;
}
